import { useCallback } from "react";
import { deleteWorkspaceApi } from "../../api/workspaceApi";
import { errorDetail } from "../../helper/errorDetail";

function useSavedSearchMetadata({
    id, setIsDeleting, setError, setDeleteDialogOpen,
    navigate, setSaveSearchSnackbar, setWorkspace, setOriginalSavedFilters
}) {
const handleSavedSearchCreated = useCallback(
    (created) => {
      setSaveSearchSnackbar({ open: true, message: "Search saved successfully." });
      const createdId = created?.id || created?._id;
      if (createdId) {
        navigate(`/workspaces/${createdId}`);
      }
    },
    [navigate, setSaveSearchSnackbar]
  );

const handleDelete = useCallback(async () => {
    if (!id) return;
    setIsDeleting(true);
    setError(null);
    try {
      const res = await deleteWorkspaceApi(id);
      if (res && (res.status === 200 || res.status === 204)) {
        setDeleteDialogOpen(false);
        navigate("/workspaces");
      } else {
        setError(errorDetail(res?.data?.detail, "Failed to delete saved search"));
      }
    } catch (_err) {
      setError("Failed to delete saved search");
    } finally {
      setIsDeleting(false);
    }
  }, [id, navigate, setDeleteDialogOpen, setError, setIsDeleting]);

const handleEditSearchSuccess = useCallback((option) => {
    if (!option) return;
    setWorkspace((prev) => ({
      ...(prev || {}),
      name: option.name || prev?.name,
      source_query: option.query || prev?.source_query,
      query: option.query || prev?.query,
    }));
    if (option.query) {
      setOriginalSavedFilters(option.query);
    }
  }, [setOriginalSavedFilters, setWorkspace]);

const handleSavedSearchBaselineChange = useCallback((query) => {
    setOriginalSavedFilters(query);
  }, [setOriginalSavedFilters]);

return {
    handleSavedSearchCreated, handleDelete, handleEditSearchSuccess, handleSavedSearchBaselineChange
};
}

export { useSavedSearchMetadata };
